/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Header } from "components/Header";
import { SearchBar } from "components/SearchBar";
import * as S from "../Occurrences/styles";
import { DashboardTemplate } from "templates/DashboardTemplate";
import { IPayment } from "interfaces/Payment";
import { orderBy } from "services/OrderBy";
import { IUser } from "interfaces/User";
import { CheckAlert } from "utils/checkAlert";
import ExportFinancialReportModal from "components/Modals/ExportFinancialReportModal";
import { FindOptionsOrder } from "interfaces/IQuery";
import Filter from "components/Filter";
import { useOccurrence } from "services/OccurrenceService";
import { OccurrenceCard } from "components/Cards/OccurrenceCard";
import { IOccurrence } from "interfaces/Occurrence";
import { useReport } from "contexts/ReportContext";
import { StepReportModal } from "components/Modals/StepReportModal";
import { DataTable } from "components/DataTable";
import { useDataList } from "hooks/useDataList";

export function Payments() {
  const [orderedPayments, setOrderedPayments] = useState<IPayment[]>([]);
  const [ordered, setOrdered] = useState("");
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(1);
  const [occurrence, setOccurrence] = useState<IOccurrence>();
  const { retrieveReport, report, resetReport } = useReport();

  const [search, setSearch] = useState("");
  const [exportModal, setExportModal] = useState(false);

  const [take, setTake] = useState(10);
  const [reportModal, setReportModal] = useState(false);
  const [order, setOrder] = useState<FindOptionsOrder<IPayment>>();

  const [storageUser, setStorageUser] = useState<IUser>();

  const occData = useOccurrence({
    filter: {
      params: [
        { report: { pr: "isNull" } } as any,
        { report: { rec: "isNull" } } as any,
      ],
    },
  }).data;

  const { data, isFetching } = useDataList<IPayment>({
    queryKey: 'getAllPayments',
    route: 'payments',
    filter: {
      page,
      order: order,
      relations: {
        policeman: { user: true },
        attendant: true,
        paymentReport: { report: true },
      },
    },
  })

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setStorageUser(JSON.parse(user));
    }
    CheckAlert();
  }, []);

  useEffect(() => {
    if (data && ordered !== "") {
      setOrderedPayments(orderBy(data.items, ordered));
    }
  }, [ordered, search]);

  return (
    <S.Container>
      <DashboardTemplate
        containerClass="wrapper"
        hasTableWrapper
        total={filter !== "notPaid" ? data?.total : occData?.item.all}
        page={page}
        setPage={setPage}
      >
        <Header title="Pagamento" />
        <Filter
          onClicks={[
            () => {
              setFilter("all");
              // setWorking(undefined);
              // setToApprove(undefined);
            },
            () => {
              setFilter("notPaid");
              // setWorking(true);
              // setToApprove(undefined);
            },
          ]}
          filter={filter}
          order={true}
          labels={[
            {
              text: `Pagamentos`,
              value: "all",
            },
            {
              text: "Ocorrências sem valor de pagamento",
              value: "notPaid",
            },
          ]}
        />
        <SearchBar
          type="text"
          name="filter"
          id="filter"
          placeholder="Procure por pronta-resposta, atendente, valor..."
          buttonText=""
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSearch(event.target.value);
          }}
          haveExport={storageUser?.role.name === "financial"}
          disabled
          required={false}
          onSaveClick={() => {
            setExportModal(true);
          }}
          onClick={() => { }}
        />
        {exportModal && (
          <ExportFinancialReportModal
            modalIsOpen={exportModal}
            setIsOpen={setExportModal}
          />
        )}
        {occData && filter === "notPaid" ? (
          <S.CardsContainer>
            {occData.item.occurrences.map((occurrence) => {
              return (
                <OccurrenceCard
                  key={occurrence.id}
                  occurrence={occurrence}
                  reportClick={() => {
                    setOccurrence(occurrence);
                    retrieveReport(occurrence);
                    setReportModal(true);
                  }}
                />
              );
            })}
          </S.CardsContainer>
        ) : (
          <DataTable
            data={data?.items}
            isFetching={isFetching}
            headers={[
              {
                field: "createdAt",
                label: "Data da declaração",
                renderColumn: (data) =>
                  new Date(data.createdAt).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }),
              },
              {
                field: "value",
                label: "Valor pago",
                renderColumn: (data) =>
                  data.value.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  }),
              },
              {
                field: "policeman",
                label: "Pronta-resposta",
                renderColumn: (data) => data.policeman.user.name,
              },
              {
                field: "attendant",
                label: "Atendente que declarou",
                renderColumn: (data) => data.attendant.name,
              },
            ]}
          />
        )}
        {report && reportModal && occurrence && (
          <StepReportModal
            opened={reportModal}
            occurrenceData={occurrence}
            setOpened={() => {
              setOccurrence(undefined);
              resetReport();
              setReportModal(false);
            }}
          />
        )}
      </DashboardTemplate>
    </S.Container>
  );
}
